export const ROW_ACTIONS = {
  EDITAR: "EDITAR",
  TOGGLE_ESTADO: "TOGGLE_ESTADO",
};
